import { compose, includes, isEmpty } from 'lodash/fp';
import { ComponentType } from 'react';
import { connect as baseConnect } from 'react-redux';
import { BreakpointRange, PORTAL_CONTAINER_ID, WithBreakpointRangeProps } from '@mews-distributor/common';
import { withBreakpointRange } from '@optimus-web/core';

import {
    getCarouselCloseIconButtonLabel,
    getCarouselNextIconButtonLabel,
    getCarouselPrevIconButtonLabel,
    getCarouselWrapperAriaLabel,
    getCategoryGalleryImagesWithFallback,
} from '../../../modules/hotels/selectors';
import { ApplicationState } from '../../../types';
import { openLightbox } from '../../../views/spaceCategories/actions';
import { CategoryCarouselProps, DispatchProps, OwnProps, StateProps } from './types';

const BREAKPOINTS_WITH_SMALL_CAROUSEL = [BreakpointRange.Phone, BreakpointRange.TabletPortrait];

export const connect = compose<
    ComponentType<CategoryCarouselProps>,
    ComponentType<OwnProps>,
    ComponentType<OwnProps & WithBreakpointRangeProps>
>(
    withBreakpointRange,
    baseConnect<StateProps, DispatchProps, OwnProps & WithBreakpointRangeProps, ApplicationState>(
        (state, { breakpointRange, categoryId }) => {
            const images = getCategoryGalleryImagesWithFallback(state, { categoryId });
            const ariaLabel = getCarouselWrapperAriaLabel(state);
            const closeIconButtonLabel = getCarouselCloseIconButtonLabel(state);
            const prevIconButtonLabel = getCarouselNextIconButtonLabel(state);
            const nextIconButtonLabel = getCarouselPrevIconButtonLabel(state);
            return {
                shouldShowLoader: !isEmpty(images),
                small: includes(breakpointRange, BREAKPOINTS_WITH_SMALL_CAROUSEL),
                images,
                lightboxPortalContainerId: PORTAL_CONTAINER_ID,
                ariaLabel,
                closeIconButtonLabel,
                prevIconButtonLabel,
                nextIconButtonLabel,
            };
        },
        {
            onCarouselImageClick: openLightbox,
        }
    )
);
